export const trainingType = [
  {
    "value": "TRAINING",
    "name": "Training"
  },
  {
    "value": "CERTIFICATION",
    "name": "Certification"
  }
]